import { CohortEnum, CohortEnumSchema } from '@eigtech/auth0-types'
import { isClaimCorn } from '@eigtech/shared-corn-helper'
import { isJobCorn } from '@eigtech/restoration-types'

export type CohortEntityType = 'claim' | 'job'

export type CohortMapping<EntityType extends string = string> = {
  check: (s: string) => boolean
  cohorts: CohortEnum[] | ((entityType: EntityType) => CohortEnum[])
}

type VisibilityEntityType = 'document' | 'note'

export const exportTargetCohortMap = {
  job: {
    check: isJobCorn,
    cohorts: [
      CohortEnumSchema.enum.csr,
      CohortEnumSchema.enum.insured,
      CohortEnumSchema.enum.technician,
    ],
  },
  claim: {
    check: isClaimCorn,
    cohorts: [
      CohortEnumSchema.enum.csr,
      CohortEnumSchema.enum.estimator,
      CohortEnumSchema.enum.insured,
      CohortEnumSchema.enum.technician,
    ],
  },
} satisfies Record<CohortEntityType, CohortMapping>

export const visibilityTargetCohortMap = {
  job: {
    check: isJobCorn,
    cohorts: (entityType) => [
      CohortEnumSchema.enum.csr,
      CohortEnumSchema.enum.technician,
      ...(entityType === 'document' ? [CohortEnumSchema.enum.insured] : []),
    ],
  },
  claim: {
    check: isClaimCorn,
    cohorts: (entityType) => [
      CohortEnumSchema.enum.csr,
      CohortEnumSchema.enum.estimator,
      ...(entityType === 'document' ? [CohortEnumSchema.enum.insured] : []),
    ],
  },
} satisfies Record<CohortEntityType, CohortMapping<VisibilityEntityType>>

export const getAvailableExportCohorts = (targets: string[] | undefined) => {
  if (!targets?.length) return []

  const availableCohorts = Object.values(exportTargetCohortMap)
    .filter(({ check }) => targets.some(check))
    .flatMap(({ cohorts }) => cohorts)
  return [...new Set(availableCohorts)]
}

export const getAvailableVisibilityCohorts = (
  targets: string[] | undefined,
  entityType: VisibilityEntityType
) => {
  if (!targets?.length) return []

  const availableCohorts = Object.values(visibilityTargetCohortMap)
    .filter(({ check }) => targets.some(check))
    .flatMap(({ cohorts }) => (typeof cohorts === 'function' ? cohorts(entityType) : cohorts))
  return [...new Set(availableCohorts)]
}
